import { getFunctions, httpsCallable } from "firebase/functions";

export const extractPdf = async (data) => {
  const functions = getFunctions();
  const callable = httpsCallable(functions, "extractPdf");

  try {
    const result = await callable(data);
    return result.data;
  } catch (error) {
    console.error("Error calling extractPdf endpoint:", error);
    throw error; // Rethrow for handling, but in our case, we catch and log without blocking
  }
};

export const extractPdfWellness = async (data) => {
  const functions = getFunctions();
  const callable = httpsCallable(functions, "extractPdfWellness");

  try {
    const result = await callable(data);
    return result.data;
  } catch (error) {
    console.error("Error calling extractPdfWellness endpoint:", error);
    throw error; // Rethrow for handling, but in our case, we catch and log without blocking
  }
};